import { corevasAxios } from "./corevasAxios"

const logout = () => {
    corevasAxios.post('auth/logout').then(response => {
        clearUserSession()
        reloadPage()
    }).catch ({ })
}

const clearUserSession = () => {
    localStorage.removeItem('AUTH_TOKEN')
    localStorage.removeItem('AUTH_USER')
}

const reloadPage = () => {
    location.reload()
}

export {
    logout,
    clearUserSession,
    reloadPage
}